import React, { createContext, useContext, useState, ReactNode } from "react";

interface CalculatorParams {
  type: string;
  term: number;
  deposit: number;
  purchasePrice: number;
  contractualMileage: number;
  car: number;
  customerType: string;
  calculatorType: string;
  schwackecode?: number;
  monthlyRate?: number;
  monthlyRateNet?: number;
  monthlyRateGross?: number;
  finalInstallment?: number;
}

interface CalculatorContextType {
  calculatorParams: CalculatorParams;
  setCalculatorParams: React.Dispatch<React.SetStateAction<CalculatorParams>>;
}

export const CalculatorContext = createContext<CalculatorContextType | any>(
  undefined
);

interface CalculatorProviderProps {
  children: ReactNode;
}

export function CalculatorProvider({ children }: CalculatorProviderProps) {
  // Define the initial state
  const [calculatorParams, setCalculatorParams] = useState<CalculatorParams>({
    type: "financing",
    term: 36,
    deposit: 4000,
    purchasePrice: 40000,
    contractualMileage: 25000,
    car: 1234,
    customerType: "business",
    calculatorType: "financing",
    schwackecode: 0,
    monthlyRate: 400,
    finalInstallment: 0,
  });

  return (
    <CalculatorContext.Provider
      value={{ calculatorParams, setCalculatorParams }}
    >
      {children}
    </CalculatorContext.Provider>
  );
}
